module.exports = __webpack_public_path__ + "img/pic1.653d0c2b.png";